import { BasiqManageConsentRequest } from "@portal-workspace/grow-shared-library";

export interface TwoFAVerificationDialogData extends BasiqManageConsentRequest {
    authenticationValue: string;
}
  
  export interface TwoFAVerificationDialogResult {
    verified: boolean;
    code?: string;
  }